<template>
  <div class="privacy-policy-container">
    <!-- 标题部分 -->
    <div class="policy-header">
      <h1>激活助手隐私政策</h1>
      <div class="effective-dates">
        <p><strong>生效日期:</strong> 2025-06-23</p>
        <p><strong>更新日期:</strong> 2025-06-23</p>
      </div>
    </div>

    <!-- 目录导航 -->
    <div class="toc">
      <h2>目录</h2>
      <ul>
        <li v-for="(section, index) in sections" :key="index">
          <a :href="'#' + section.id">{{ section.title }}</a>
        </li>
      </ul>
    </div>

    <!-- 主要内容区域 -->
    <div class="policy-content">
      <!-- 引言 -->
      <section id="introduction">
        <h2>引言</h2>
        <p>欢迎您使用我们的产品和服务!我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全可控。</p>
        <p>
          基于此，激活助手服务提供者(或简称"我们")制定本《激活助手隐私政策》(下称"本政策"/"本隐私政策")，帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。
        </p>
        <p class="sensitive-info">您知悉并理解，我们向您提供的部分服务可能需要处理您的敏感个人信息。该等敏感个人信息会采用粗体字加下划线进行标注以提示您注意。</p>
      </section>

      <!-- 适用范围 -->
      <section id="scope">
        <h2>一、适用范围</h2>
        <p>
          本政策仅适烟台微步网络科技有限公司(以下称"微步"或"我们")提供的激活助手服务。该服务可承载于网站、移动客户端、小程序以及随技术发展出现的新形态。该服务可能适配在多种智能终端，包括电脑、智能手机、巴枪以及其他IoT设备等。
        </p>
      </section>

      <!-- 收集使用个人信息 -->
      <section id="collection">
        <h2>二、我们如何收集及使用您的个人信息</h2>
        <p>在您使用我们的产品/服务时,我们需要/可能需要收集和使用的您的个人信息包括如下两种:</p>

        <h3>(一)为实现向您提供我们产品及/或服务的基本功能,您须授权我们收集、使用的必要的信息。</h3>
        <p>如您拒绝提供相应信息,您将无法正常使用我们的全部或部分产品及/或服务;</p>

        <h3>(二)为实现向您提供我们产品及/或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。</h3>
        <p>如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果,但不会影响您使用我们的基本功能。</p>

        <h3>基本功能包括:</h3>

        <h4>1. 帮助您注册账号及账号管理</h4>
        <p>为了使用激活助手的服务，您需要拥有一个激活助手账号。您可以通过以下方式注册激活助手账号:</p>
        <p>1、通过您的手机号码注册。如果您选择通过这种方式注册菜鸟账号，您需要向我们提供您的手机号码。</p>
        <p>2、通过账号密码注册。如果您通过这种方式注册，您需要向我们提供您的账号密码。</p>

        <h4>2. 为您进行实名认证</h4>
        <p>在您使用激活助手的部分功能前，根据相关法律法规规定，我们需要对您进行实名认证，您需要身份证信息提供给我们。在您以上述方式完成实名认证后，即可使用我们的完整功能。</p>

        <h4>3. 为您进行实人认证</h4>
        <p>
          您在使用激活助手时,我们可能不时地需要对您的身份进行抽检以确保是您本人在为消费者提供服务,为此您需要不时地通过我们对您进行的实人认证。因此,您需要提交您的实人认证信息,包括您的<strong><u>实时面部照片</u></strong>以及您的<strong><u>身份证所载身份信息</u></strong>(包括您的姓名、面部照片、身份证号码)。
        </p>

        <h4>4. 为您进行背景调查</h4>
        <p>为了您能正常使用接单功能,向客户提供温馨安全的物流服务,您需要授权我们可从合法保存您信息的第三方处获取您的背景调查信息，包括确认您是否有不适合作为物流服务人员的不良记录。</p>

        <h4>5. 帮助您进行揽收、派送</h4>
        <p>
          为了使您可以使用激活助手的揽收派送服务，以及在此过程中和消费者进行沟通，我们可能需要收集您的位置信息，姓名、电话号码、菜鸟会员账号信息、以及读写您的本地文件如照片。请注意，在您进行揽收派送作业时，我们需要持续收集您的位置信息，以便获取您的揽派轨迹以及时通知收寄件人，或是判断您是否在指定范围内作业。
        </p>
        <p>同时，当您使用查找揽收派件任务、扫码等功能时，我们可能会需要获取您的剪切板信息，以便帮助您快捷复制运单号（以您使用的具体功能为准），我们仅会在您的设备上识别、处理您的剪切板信息，并且不会存储您的剪切板信息。</p>

        <h4>6. 消息通知</h4>
        <p>
          我们在运营中可能会通过您在使用产品及/或服务的过程中所提供的联系方式（如联系电话、联系邮箱），向您同时发送一种或多种类型的通知，例如互动消息、服务通知等。我们会通过客户端"系统消息"，向您推送平台通知。您可以在您的设备"设置"中选择开启/关闭激活助手App的通知权限，或通过激活助手App中"我的"—"设置"—"隐私"—"全部权限设置"进行消息通知设置。我们也可能通过弹窗向您发送消息。如您希望关闭弹窗推送信息，您可以通过相关按钮进行关闭。
        </p>

        <h4>7. 为您提供客服服务</h4>
        <p>为了向您提供客服与售后服务，我们会收集您与我们的客服联系时主动提供的信息例如照片、工号、电话号码，您参与问卷调查时提供的问卷答复信息、以及您与激活助手进行互动时提供的其他信息。</p>
        <h4>8. 保障您的交易安全</h4>
        <p>
          当您使用激活助手时，为保障您正常使用我们的服务，我们会自动接收并记录您的设备位置和移动设备相关的信息，包括但不限于：为了进行单点登录识别，我们将收集您的设备环境、设备厂商、设备型号、Wifi信息、设备识别标识（如IMEI、IMSI、MAC地址）；为了使您可以拨打电话以及发送短信，我们将收集您的电信运营商信息；这类信息是为提供服务必须收集的基础信息，您使用激活助手，即意味着您授权我们收集您的这些信息，若您拒绝提供这类信息，您将无法正常使用我们的服务。
        </p>
        <p>
          除了以上基本功能外，为了使您更便捷地使用激活助手的服务，我们会为您提供各项附加功能。为了向您提供这些附加功能，我们可能会收集和使用您的个人信息。如果您不提供这些信息，您依然可以使用激活助手的基本功能，但您可能无法使用这些可以为您带来便捷的附加功能或者需要重复填写一些信息。这些附加功能包括：
        </p>
        <h4>9. 为您提供小件员专属权益</h4>
        <p>
          我们及我们的合作方可能时不时地向您提供小件员专属权益，例如小件员专属电话卡或小件员专属保险。如果您希望享受这类权益，您需要提供相关法律法规规定的个人信息。例如，如果您希望领取小件员专属电话卡，您需要提供您的姓名、身份证号码，及其他法律法规规定的办理电话卡所必须提供的个人信息。
        </p>
        <h4>10. 年报信息总结</h4>
        <p>
          为了为您提供您的年报信息总结，我们会使用您的下列个人信息：姓名、手机号码、职业信息、订单送达目的地信息、订单收件人联系信息、位置信息、设备信息、订单行程信息、订单信息及交易状态、评价信息、服务天数、揽派件量、星级奖励金额、任务奖励金额。
        </p>
        <h4>11. 基于系统权限的附加功能</h4>
        <p>
          为向您提供更便捷、更优质的产品及/或服务，努力提升您的体验，我们可能会通过开启系统权限以收集和使用您的个人信息。如果您不同意开启相关权限，不会影响您使用激活助手的基本服务，但您可能无法获得这些附加服务给您带来的用户体验。
        </p>
        <p>您可自行决定这些权限随时的开启或关闭。</p>
        <p>
          请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
        </p>
        <p>您可点击此处查看应用权限申请与使用情况说明。</p>
        <h4>12. 基于Cookie和同类技术的附加功能</h4>
        <p>
          Cookie和同类设备信息标识技术是互联网中普遍使用的技术。当您使用我们的服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符（以下简称"Cookie"），以收集、标识和存储您访问、使用本产品时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie主要为了保障产品与服务的安全、高效运转，可以使我们确认您账号与交易的安全状态，排查崩溃、延迟的相关异常情况，帮助您省去重复您填写表单、输入搜索内容的步骤和流程。
        </p>
        <p>
          为了使您可以使用激活助手的揽收派送服务，以及在此过程中和消费者进行沟通，我们可能需要收集您的位置信息，姓名、电话号码、菜鸟会员账号信息、以及读写您的本地文件如照片。请注意，在您进行揽收派送作业时，我们需要持续收集您的位置信息，以便获取您的揽派轨迹以及时通知收寄件人，或是判断您是否在指定范围内作业。
        </p>
      </section>

      <!-- 信息共享 -->
      <section id="sharing">
        <h2>三、我们如何委托处理、共享、转让，或公开披露您的个人信息</h2>

        <h3>共享</h3>
        <p>我们对您的个人信息承担保密义务,不会为满足第三方的营销目的而向其出售或出租您的任何个人信息。我们仅会在下列情况下才将您的个人信息与第三方共享:</p>
        <ol>
          <li>履行法定义务所必需的共享:我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，共享您的个人信息。</li>
          <li>取得您同意的情况下共享:获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
          <li>只有共享您的个人信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。</li>
          <li>如您出现违反中国有关法律、法规的情况，需要向第三方共享。</li>
          <li>为维护配送员、物流合作伙伴、用户或公众的人身财务安全免遭侵害。</li>
          <li>
            为了使您能够接收信息推送、在第三方平台分享信息、使用地图服务等功能用途，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本指引以及其他任何相关的保密和安全措施来处理个人信息。
          </li>
        </ol>
        <p>请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎地考虑并做出决定。</p>

        <h3>第三方SDK信息共享</h3>
        <p>为了实现本政策所述功能，我们的应用中会嵌入授权合作伙伴的SDK。以下是我们接入的第三方SDK及其收集使用个人信息的详细说明：</p>

        <table class="sdk-table">
          <thead>
            <tr>
              <th>第三方公司名称</th>
              <th>产品/类型</th>
              <th>共享信息名称/个人信息类型</th>
              <th>使用目的/功能及服务</th>
              <th>使用场景/信息采集方式</th>
              <th>共享方式</th>
              <th>第三方个人信息处理规则</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>上海七牛信息技术有限公司</td>
              <td>七牛上传 SDK</td>
              <td>厂商、机型、系统版本；网络类型（例如 Wi-FI、3G、4G）</td>
              <td>用于判断用户的的手机类型，以备兼容性及问题排查；用于通信质量不佳时的问题排查</td>
              <td>文件上传场景</td>
              <td>调用系统相关接口自动采集</td>
              <td><a href="https://developer.qiniu.com/pili/8027/sdk-privacy-policy" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>微信开放平台</td>
              <td>/</td>
              <td>支持微信登录，微信分享</td>
              <td>使用微信授权登录分享</td>
              <td>SDK本机采集</td>
              <td><a href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>TBS;腾讯浏览器;腾讯X5浏览器</td>
              <td>手机型号、剪切板</td>
              <td>保证服务的准确性、有效性；保证搜索、分享等功能的实现</td>
              <td>准确控制内核版本下发和开关下发；用户搜索、分享已复制的内容</td>
              <td>SDK本机采集</td>
              <td><a href="https://x5.tencent.com/tbs/guide/develop.html" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>Bugly Android 性能监控类</td>
              <td>手机型号、品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID</td>
              <td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机型号、品牌、Android系统版本、系统api等级、厂商系统版本、cpu架构有关；在APP发生闪退时，识别Crash等问题是否是由于root、磁盘剩余空间小、sdcard剩余空间小、内存空间小、网络类型导致；在APP发生闪退时，判断当前进程的ANR状态，排查崩溃问题, 帮助APP提升稳定性</td>
              <td>收集崩溃信息</td>
              <td>SDK本机采集</td>
              <td><a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>高德</td>
              <td>高德地图</td>
              <td>设备信息（如设备标识信息（IDFA、OAID、IMEI、MAC）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）、IP地址、GNSS信息、网络类型、SSID、BSSID、WiFi状态、WiFi参数、WiFi列表、WiFi信号强度的信息、基站信息传感器信息（矢量、加速度、压力）、设备信号强度信息、WiFi网关地址）、位置信息、服务日志信息，外部存储状态</td>
              <td>用于定位和地图展示</td>
              <td>定位，地图展示</td>
              <td>SDK本机采集</td>
              <td><a href="https://lbs.amap.com/pages/privacy/" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>友盟同欣（北京）科技有限公司</td>
              <td>友盟统计分析SDK</td>
              <td>设备信息（MAC/Android ID/IDFA/OAID/OpenUDID/GUID）、位置信息、网络信息</td>
              <td>进行APP运营统计与分析</td>
              <td>SDK直接采集</td>
              <td>-</td>
              <td><a href="https://www.umeng.com/page/policy" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>Blankj</td>
              <td>BlankjUtilCode</td>
              <td>读取剪贴板</td>
              <td>获取用户下载渠道进行运营统计</td>
              <td>SDK直接采集</td>
              <td>-</td>
              <td><a href="https://github.com/Blankj/AndroidUtilCode?tab=Apache-2.0-1-ov-file" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>北京旷视科技有限公司</td>
              <td>FaceID 人脸SDK</td>
              <td>设备信息，重力传感器信息，陀螺仪传感器信息、传感器数量、是否存在蓝牙/闪光灯、VPN、充电状态等；应用信息，含已安装异常应用、异常文件、异常系统进程；证件芯片中加密的文本（如姓名、身份证号码等）与人脸照片信息；活体检测期间屏幕所展示内容的录屏视频、系统播报声音 & 环境声音</td>
              <td>SDK人脸识别过程中纠正用户姿态，提升采集质量；用于设备风险检测等SDK安全保障；完成实体证件解析；保障人脸识别、活体检测等SDK功能安全进行并完成留证</td>
              <td>SDK初始化接口传参配置，集成 SDK 产品类型控制</td>
              <td>-</td>
              <td><a href="https://assets.faceid.com/faceidopen/privacy-policy.html?ts=1681374200" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>杭州阿里云智能科技有限公司</td>
              <td>金融级实人认证SDK</td>
              <td>（1）设备基础信息：设备制造商、设备品牌、设备类型及型号、设备名称、设备操作系统信息、设备内存及存储大小、电池及电量信息、基带信息、开机时间、屏幕亮度及分辨率、CPU信息、系统时区、系统语言、充电状态、系统内核信息、传感器列表、光线传感器信息；（2）设备标识信息：IDFA （可选）、IDFV、Android ID、OAID；（3）设备网络信息：BSSID、SSID、运营商信息、网络类型、SIM卡状态；（4）设备应用信息：SDK宿主APP信息（包括：宿主APP应用名称、宿主APP应用版本、宿主APP安装时间）</td>
              <td>身份认证</td>
              <td>SDK直接采集</td>
              <td>-</td>
              <td><a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107281509_18386.html" target="_blank">查看隐私政策</a></td>
            </tr>
            <tr>
              <td>支付宝支付科技有限公司</td>
              <td>App 支付宝客户端 SDK</td>
              <td>AndroidID、OAID、IDFV、传感器信息（传感器列表）、设备屏幕密度、运营商信息、WIFI参数、网络类型</td>
              <td>a. 保障用户账户和资金安全以及支付服务的安全稳定运行。b. 履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。c. 实现网络链路的选择和优化，以提升用户体验。</td>
              <td>SDK直接采集</td>
              <td>-</td>
              <td><a href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132" target="_blank">查看隐私政策</a></td>
            </tr>
          </tbody>
        </table>
        <div style="width: 100%;"> 详细信息请查看:<a href="https://jhzs.weibu.vip/third_info_share.html" target="_blank">第三方SDK信息共享清单</a></div>

        <h3>转让</h3>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外:</p>
        <ol>
          <li>获得您的明确单独同意后,我们会向其他方转让您的个人信息;</li>
          <li>
            在我们发生合并、收购或破产清算情形,或其他涉及合并、收购或破产清算情形时,如涉及到个人信息转让,我们会要求新的持有您个人信息的公司、组织继续受本隐私保护指引的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
          </li>
        </ol>

        <h3>公开披露</h3>
        <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
        <ol>
          <li>获得您明确单独同意或基于您的主动选择，我们会公开披露您的个人信息；</li>
          <li>如果我们确定您有违反法律法规的情形，或为保护激活助手用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违法行为以及激活助手已对您采取的措施。</li>
        </ol>

        <h3>停止运营</h3>
        <p>如果我们停止运营产品或服务，将及时停止继续收集您的用户信息。我们会逐一送达通知或以公告的形式向您发送停止运营的告知，并对我们所持有的与已关停的产品或服务相关的用户信息进行删除或匿名化处理。</p>

        <h3>依法豁免征得您的授权同意的情形</h3>
        <p>请您理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开您的用户信息无需征得您的授权同意：</p>
        <ol>
          <li>根据您的要求订立或履行合同所必需。</li>
          <li>为履行法定职责或者法定义务所必需：我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，共享您的用户信息。</li>
          <li>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需。</li>
          <li>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理用户信息。</li>
          <li>在合理的范围内处理你自行公开的用户信息，或者其他已经合法公开的用户信息（如合法的新闻报道、政府信息公开等渠道合法公开的用户信息）。</li>
          <li>法律法规规定的其他情形。</li>
        </ol>

      </section>

      <!-- 信息存储 -->
      <section id="storage">
        <h2>四、我们如何存储您的个人信息</h2>

        <h3>存储期限</h3>
        <p>
          我们仅会在为达成本指引所述目的所需期限内保留您的个人信息，除非法律有强制的存留要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于3年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准:
        </p>
        <ol>
          <li>完成与您相关的交易目的、维护相应交易及业务记录,以应对您可能的查询或投诉;</li>
          <li>保证我们为您提供服务的安全和质量;</li>
          <li>您是否同意更长的留存期间;</li>
          <li>是否存在保留期限的其他特别约定。</li>
        </ol>
        <p>当我们的产品或服务发生停止运营的情形时，我们将至少提前15个工作日以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>

        <h3>存储位置</h3>
        <p>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，且不会将有关个人信息向境外提供。</p>
      </section>

      <!-- 用户权利 -->
      <section id="protection">
        <h2>五、我们如何保护您的个人信息</h2>
        <p>我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受
          SSL协议加密保护；我们同时对配送员提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </p>
        <p>我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。</p>
        <p>我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。</p>
        <p>
          互联网并非绝对安全的环境，使用激活助手服务时，我们强烈建议您不要使用非激活助手推荐的通信方式发送您的信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。在使用激活助手进行派送和激活操作时，您可能不可避免地要向合作快递物流服务商或潜在的快递物流服务商披露自己的个人信息，如您的姓名及联络方式。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账号或密码发生泄露，请您立即联络激活助手客服，以便我们根据您的申请采取相应措施。请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </p>
        <p>我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过激活助手公告方式获得。</p>
        <p>
          在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </p>
      </section>

      <!-- 用户权利 -->
      <section id="rights">
        <h2>六、您的权利</h2>
        <p>您可以通过以下方式查阅和管理您的信息，我们会在符合法律法规要求的情形下响应您的请求:</p>

        <h3>(一)查阅、复制或转移您的个人信息</h3>
        <p>您有权通过以下方式查阅、复制或转移您的信息:</p>
        <p>
          若您需要查询或复制您的个人信息，您可以登录激活助手App，在"我的-个人信息"页面查询您的姓名、头像、手机号码等信息;如果您进行了实名认证、身份核验或实人认证、资质认证，您还可以按照前述方式查询您在认证时提交的相关信息。如果您无法通过上述方式查询您的个人信息，您可以通过jihuozhushou@163.com直接联系我们提出相关要求。
        </p>

        <h3>(二)更正和补充您的个人信息</h3>
        <p>
          若您在注册账号或使用激活助手服务过程中提供的信息有变化或需要补充,您可以登录激活助手App,在"我的-个人信息"页面更新您的个人信息。如果您无法以上述方式更新或补充您的个人信息，您可以通过jihuozhushou@163.com直接联系我们提出相关要求。
        </p>

        <h3>(三)删除您的个人信息</h3>
        <p>您可以通过申请注销账号删除您的全部信息,或者也可以通过联系我们的个人信息保护专职部门进行删除。</p>
        <p>若发生如下任一情形，或满足《个人信息保护法》第四十七条相关情形的，您可以按照本政策第九条列明的联系方式提出删除您的个人信息的请求：</p>
        <ol>
          <li>如果我们处理个人信息的行为违反法律法规；</li>
          <li>如果我们收集、使用您的个人信息，却未征得您的明确同意；</li>
          <li>如果我们处理个人信息的行为严重违反了与您的约定；</li>
          <li>如果您不再使用激活助手服务，且已按照注销流程注销激活助手账号的；</li>
          <li>如果我们永久不再为您提供产品或服务。</li>
        </ol>
        <p>如果我们决定响应您的删除请求，我们将同时尽可能通知从我们获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</p>
        <p>当我们响应您的删除请求时，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，但我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</p>

        <h3>（四）注销您的账号</h3>
        <p>如果您希望注销激活助手账户，您可以在“我的-设置-注销”中进行自主操作。您也可以通过ihuozhushou@163.com提交注销申请。</p>
        <p>在您的账户注销之后，我们将停止为您提供产品或服务，并将根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。</p>

        <h3>（五）对本政策进行解释说明</h3>
        <p>如果您对本政策有任何疑问的，您可以通过本政策第九条所列的联系方式直接联系我们要求对本政策进行解释说明。</p>

        <h3>（六）去世用户的个人信息权利保障</h3>
        <p>
          如果您认为激活助手处理了您已去世的近亲属的个人信息，您可以为了您自身的合法、正当利益，通过本政策第九条所列的联系方式直接联系我们，要求对该近亲属的个人信息行使查阅、复制、更正、删除等权利，但您的该近亲属生前另有安排的除外。
        </p>
        <p>
          您理解并确认，为了充分保护去世用户的个人信息权益，如果您根据本条申请行使去世用户的个人信息权利，您可能需要根据我们的指定流程或客服提示，提交去世用户的身份证明文件、死亡证明文件、您本人的身份证明文件、您本人和去世用户的亲属关系证明文件，并提供申请行使的个人信息权利类型以及目的。
        </p>

        <h3>（七）响应您的上述请求</h3>
        <p>
          对于您或可能的您的监护人、近亲属及其他有权主体向我们提出的上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您可以通过联系我们的个人信息保护专职部门来提起相关请求。我们将在15个工作日内做出答复。
        </p>
        <p>为保障您的账号安全和您的个人信息安全，您向我们提出上述请求时，我们可能会先验证您的身份（如增加账号核验、要求您提供书面请求或其他合理方式），然后再处理您的请求。</p>
        <p>
          对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。此外，在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        </p>
        <ol>
          <li>与国家安全、国防安全有关的；</li>
          <li>与公共安全、公共卫生、重大公共利益有关的；</li>
          <li>与犯罪侦查、起诉、审判和执行判决等有关的；</li>
          <li>有充分证据表明个人信息主体存在主观恶意或滥用权利的；</li>
          <li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
          <li>涉及商业秘密的；</li>
          <li>与我们履行法律法规规定的义务相关的；</li>
          <li>出于维护个人信息主体或其他个体的生命、财产等重大合法权益但又很难得到本人授权同意的。</li>
        </ol>

      </section>

      <!-- 用户权利 -->
      <section id="minors">
       <h2>七、我们如何处理未成年的个人信息</h2>
      <p>
        激活助手不向未成年人提供服务。若您是不满十八周岁的未成年人，请不要注册账号或发送自己的姓名、住址、电话、邮件地址等个人信息给我们。如果您认为我们可能不当地持有来自于或关于未成年人的信息，请联系我们。
      </p>
      </section>


      <!-- 用户权利 -->
      <section id="update">
       <h2>八、政策如何更新</h2>
      <p>为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策以告知您具体的变化。未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。对于重大变更，我们还会以推送通知、弹窗的形式等更为显著的方式向您展示变更后的指引。</p>
      <p>前述重大变更包括但不限于:</p>
      <p>（一）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
      <p>（二）我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；</p>
      <p>（三）个人信息共享、转让或公开披露的主要对象发生变化；</p>
      <p>（四）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
      <p>（五）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
      <p>（六）其他可能对您的个人信息权益产生重大影响的变化。</p>
      </section>


      <!-- 联系我们 -->
      <section id="contact">
        <h2>九、如何联系我们</h2>
        <p>您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求:</p>

        <p>(一)如您对本隐私政策内容有任何疑问、意见或建议,您可通过: <a href="mailto:jihuozhushou@163.com">jihuozhushou@163.com</a> 与我们联系;</p>

        <p>(二)我们还设立了个人信息保护专职部门,您可以通过: <a href="mailto:jihuozhushou@163.com">jihuozhushou@163.com</a>
          与其联系(请您注明与激活助手有关，并说明具体事实情况),办公地址:山东省烟台市莱山区观海路116号装饰大厦4楼401。</p>

        <p class="note">需注意的是,我们可能不会回复与本隐私政策或您的个人信息权利无关的问题。</p>

        <p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</p>
      </section>

      <!-- 联系我们 -->
      <section id="definition2">
        <h2>附录：相关定义</h2>
        <p>激活助手服务提供者：烟台微步网络科技有限公司</p>
        <p>个人信息：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</p>
        <p>敏感个人信息：敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹信息，以及不满十四周岁未成年人的个人信息。</p>
        <p>设备信息：包括设备标识符（IMEI、IDFA、Android ID、MAC、OAID、IMSI及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息），设备网络环境信息（IP地址，WiFi信息，基站信息及其他网络相关信息）、传感器、剪切板。以产品实际采集情况为准。</p>
        <p>服务日志信息：包括浏览记录、点击查看记录、搜索查询记录、收藏、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。</p>
        <p>去标识化：指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</p>
        <p>匿名化：指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
      </section>

    </div>

  </div>
</template>

<style scoped>
.privacy-policy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
}

.policy-header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.policy-header h1 {
  font-size: 24px;
  margin-bottom: 15px;
}

.effective-dates {
  display: flex;
  justify-content: center;
  gap: 30px;
  color: #666;
  font-size: 14px;
}

/* 目录样式 */
.toc {
  background-color: #f8f9fa;
  padding: 15px 20px;
  margin-bottom: 30px;
  /*border-left: 4px solid #3498db;*/
}

.toc h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

.toc ul {
  padding-left: 20px;
}

.toc li {
  margin-bottom: 8px;
}

.toc a {
  color: #3498db;
  text-decoration: none;
}

.toc a:hover {
  text-decoration: underline;
}

/* 内容样式 */
.policy-content {
  margin-bottom: 40px;
}

.policy-content section {
  margin-bottom: 40px;
}

h2 {
  font-size: 20px;
  margin: 30px 0 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

h3 {
  font-size: 17px;
  margin: 25px 0 10px;
  font-weight: 600;
}

h4 {
  font-size: 16px;
  margin: 20px 0 10px;
  font-weight: 600;
}

p {
  margin-bottom: 15px;
  text-align: justify;
}

ol,
ul {
  padding-left: 30px;
  margin-bottom: 20px;
}

li {
  margin-bottom: 8px;
}

.sensitive-info {
  background-color: #fff8e1;
  padding: 10px 15px;
  /* border-left: 3px solid #ffb300; */
  margin: 15px 0;
}

.note {
  font-style: italic;
  color: #666;
  margin: 15px 0;
}

a {
  color: #2980b9;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* SDK表格样式 */
.sdk-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 14px;
  background-color: #fff;
}

.sdk-table thead {
  background-color: #f8f9fa;
}

.sdk-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #3498db;
  color: #333;
  white-space: nowrap;
}

.sdk-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #eee;
  vertical-align: top;
  line-height: 1.5;
}

.sdk-table tbody tr:hover {
  background-color: #f8f9fa;
}

.sdk-table tbody tr:last-child td {
  border-bottom: none;
}

.sdk-table a {
  color: #3498db;
  text-decoration: none;
}

.sdk-table a:hover {
  text-decoration: underline;
}

/* 同意按钮 */
.accept-container {
  text-align: center;
  margin: 40px 0;
}

.agree-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.agree-button:hover {
  background-color: #2980b9;
}

/* 页脚 */
footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #777;
  font-size: 14px;
}
</style>








<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { url, login, getdoown } from '@/assets/js/common.js'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  data() {
    return {
      sections: [
        { id: 'introduction', title: '引言' },
        { id: 'scope', title: '一、适用范围' },
        { id: 'collection', title: '二、我们如何收集及使用您的个人信息' },
        { id: 'sharing', title: '三、我们如何委托处理、共享、转让，或公开披露您的个人信息' },
        { id: 'storage', title: '四、我们如何存储您的个人信息' },
        { id: 'protection', title: '五、我们如何保护您的个人信息' },
        { id: 'rights', title: '六、您的权利' }, 
        { id: 'minors', title: '七、我们如何处理未成年的个人信息' }, 
        { id: 'update', title: '八、政策如何更新' },
        { id: 'contact', title: '九、如何联系我们' },
        { id: 'definition', title: '附录：相关定义' }
      ]
    }
  },
  mounted() {



  },
  methods: {
    // login(){
    //   login({'type':'111'}).then((response)=>{
    //     console.log(response)
    //   })
    // },?category_id=1&type=1
    // getdownload(){

    // }
  }
}
</script>
<style scoped>
.t_home {
  padding: 20px;
  font-size: 13px;
}

h1 {
  font-size: 18px;
}

h2 {
  font-size: 16px;
}

h3 {
  font-size: 15px;
}
</style>